import React from "react";
import "./Footer.css";
import { Link, Stack, Typography, Box, Divider } from "@mui/joy";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CoffeeIcon from "@mui/icons-material/Coffee";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "Federal", path: "/bills" },
  { label: "State", path: "/state-bills" },
  { label: "Legislators", path: "/legislators" },
  { label: "Resources", path: "/resources" },
];

const Footer = () => {
  const navigate = (path) => {
    window.history.pushState({}, "", path);
    const navEvent = new PopStateEvent("popstate");
    window.dispatchEvent(navEvent);
  };

  const handleNavigation = (event, path) => {
    event.preventDefault();
    navigate(path);
  };

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "white",
        borderTop: "1px solid #e5e7eb",
        color: "#111928",
      }}
    >
      <Box
        sx={{
          maxWidth: "1440px",
          margin: "0 auto",
          padding: { xs: "3rem 1.25rem", md: "4rem 2rem" },
        }}
      >
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={{ xs: 4, md: 8 }}
          sx={{ justifyContent: "space-between" }}
        >
          <Stack spacing={2.5} sx={{ flex: 1, maxWidth: { md: "360px" } }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: "7px",
                  backgroundColor: "var(--ce-accent)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <AccountBalanceIcon sx={{ color: "white", fontSize: 18 }} />
              </Box>
              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: 700,
                  color: "#111928",
                  letterSpacing: "-0.01em",
                }}
              >
                CivicEngage
              </Typography>
            </Box>
            <Typography
              level="body-sm"
              sx={{ color: "#637381", lineHeight: 1.7, fontSize: "16px" }}
            >
              Empowering citizens to understand legislation and take action on
              issues that matter. Making civic engagement accessible, simple,
              and effective for everyone.
            </Typography>
          </Stack>

          <Stack spacing={2}>
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: 600,
                color: "#111928",
              }}
            >
              Navigation
            </Typography>
            <Stack spacing={1.25}>
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  href={link.path}
                  underline="none"
                  onClick={(e) => handleNavigation(e, link.path)}
                  sx={{
                    color: "#637381",
                    fontSize: "16px",
                    fontWeight: 400,
                    transition: "color 0.15s ease",
                    "&:hover": { color: "#111928" },
                    "@media (prefers-reduced-motion: reduce)": { transition: "none" },
                  }}
                >
                  {link.label}
                </Link>
              ))}
            </Stack>
          </Stack>

          <Stack spacing={2}>
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: 600,
                color: "#111928",
              }}
            >
              Support
            </Typography>
            <Stack spacing={3}>
              <Link
                href="https://www.buymeacoffee.com/martinuzzif"
                target="_blank"
                rel="noopener noreferrer"
                underline="none"
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  padding: "9px 24px",
                  borderRadius: "6px",
                  fontSize: "16px",
                  fontWeight: 600,
                  backgroundColor: "var(--ce-accent)",
                  color: "white",
                  width: "fit-content",
                  minHeight: "48px",
                  transition: "opacity 0.15s ease",
                  "&:hover": { opacity: 0.88 },
                  "@media (prefers-reduced-motion: reduce)": { transition: "none" },
                }}
              >
                <CoffeeIcon sx={{ fontSize: 20 }} />
                Buy me a coffee
              </Link>
              <Typography sx={{ color: "#637381", fontSize: "16px" }}>
                &copy; 2026 Jordan Martinuzzi. All rights reserved.
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default Footer;
